export default "__VITE_ASSET__BJvntrHj__"